import React from 'react';
import { DashboardOutlined, EditOutlined, LineChartOutlined, TableOutlined } from '@ant-design/icons';
import { EDIT_SURVEY } from 'shared/constants/permissions';
import SurveyResults from 'containers/Results/SurveyResults';
import SurveyList from './SurveyList';
import SurveysDashboard from './SurveysDashboard';
import EditSurvey from './EditSurvey';

const routes = [
  {
    path: 'dashboard',
    label: 'Dashboard',
    icon: <DashboardOutlined />,
    component: SurveysDashboard,
  },
  {
    path: 'list',
    label: 'Survey list',
    component: SurveyList,
    icon: <TableOutlined />,
  },
  {
    path: 'results',
    label: 'Survey results',
    component: SurveyResults,
    link: false,
    icon: <LineChartOutlined />,
    defaultOpen: true,
    emptyLabel: 'No surveys',
  },
  {
    type: 'divider',
    dataSourcePermission: EDIT_SURVEY,
  },
  {
    path: 'edit',
    label: 'Survey editor',
    component: EditSurvey,
    link: false,
    icon: <EditOutlined />,
    dataSourcePermission: EDIT_SURVEY,
    emptyLabel: 'No surveys',
  },
];

export default routes;
